import { render, staticRenderFns } from "./indonesian_native_teacher_classB.vue?vue&type=template&id=45e0f5b5&scoped=true"
import script from "./indonesian_native_teacher_classB.vue?vue&type=script&lang=js"
export * from "./indonesian_native_teacher_classB.vue?vue&type=script&lang=js"
import style0 from "./indonesian_native_teacher_classB.vue?vue&type=style&index=0&id=45e0f5b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0f5b5",
  null
  
)

export default component.exports